import React from "react";
import Icon from "./Icon";

const StatusCardBookSvg = () => {
  return (
    <div>
      <Icon name="blogBook" className=" h-6 w-6 text-inherit" strokeWidth="1.5" />
    </div>
  );
};

export default StatusCardBookSvg;
